<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Charities</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createCharity">Add Charity</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="charities.columns" :data="charities.data">
                    <template slot="table-row" v-if="charities.data.length">
                        <tr v-for="(item, index) in charities.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.givingName}}</td>
                          <td><a :href="item.website" target="_blank">{{item.website}}</a></td>
                            <td ><img class="table-thumbnail" :title="item.imageUrl":src="item.imageUrl" /></td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewCharity(item)" v-tooltip.top-center="charities.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editCharity(item)" v-tooltip.top-center="charities.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const charitiesColumns = ['Charity Name','Website', 'Image', 'Status', 'Operations'];
    export default {
        name: 'Charities',
        components: {
            LTable,
        },
        data() {
        return {
              charities: {
                tooltips: {
                    view: 'View charity',
                    edit: 'Edit charity',
                    delete: 'Inactivate Charity',
                    activate:'Activate Charity',
                },
                columns: [...charitiesColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchCharities () {
            this.$store.dispatch('FETCH_CHARITIES')
                    .then((res) => {
                        this.charities.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewCharity(giving){
            this.$router.push({ name: 'CharityDetail', params: { id: giving.givingId}})
        },
        editCharity(charity){
            this.$router.push({ name: 'EditCharity', params: { id: charity.givingId}})
        },
        createCharity(){
            this.$router.push({ name: 'CreateCharity'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchCharities();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charities/Charities.vue